export const catagoryInfo=[
    {
        title: "electronics",
        price: 13.5,
        description: 'lorem ipsum set',
        image: 'https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_TV_2X._SY304_CB432517900_.jpg',
        category: 'electronic'
    },
    {
        title: "women's clothing",
        price: 13.5,
        description: 'lorem ipsum set',
        image: 'https://images-na.ssl-images-amazon.com/images/G/01/softlines/shopbop/ingress/2023/March/mp_20230219_ff_desktopsinglecategory_desktop_379x304_1._SY304_CB612639047_.jpg',
        category: 'electronic'
    }, 
    {
        title:"men's clothing",
        price: 13.5,
        description: 'lorem ipsum set',
        image: 'https://m.media-amazon.com/images/I/51ZBLbd3yhL._SR240,220_.jpg',
        category: 'electronic'
    },
    {
        title: "jewelery",
        price: 13.5,
        description: 'lorem ipsum set',
        image: 'https://m.media-amazon.com/images/I/81HiqHEF2wL._AC_UL320_.jpg',
        category: 'electronic'
    }
    
]